import {
  DESKTOP_MIN_PX,
  LAPTOP_LG_MIN_PX,
  LAPTOP_MIN_PX,
  LAPTOP_SM_MIN_PX,
  TABLET_MIN_PX,
} from "lib/providers/Responsive";

/**
 * Layout-tier media queries for Emotion object syntax, exposed on the theme as
 * `theme.breakpoints` — e.g. `[theme.breakpoints.laptopUp]: { padding: 24 }`.
 *
 * Use these instead of hand-writing `@media (min-width: 1280px)`, so the pixel boundaries stay
 * defined once. The `media-*` mixins in media_queries.scss cover the same tiers for SCSS;
 * media_queries.test.ts fails if the two drift apart.
 */
// Upper bounds sit just under the next tier's minimum rather than a whole pixel below it. Viewport
// widths can be fractional (Windows display scaling, browser zoom), so `max-width: 767px` paired
// with `min-width: 768px` leaves 767.5px matching neither — while calculateLayoutTier() still calls
// it "mobile", so the JS renders the mobile nav with none of the mobile CSS applied.
const BELOW = 0.02;

export const mq = {
  mobileOnly: `@media (max-width: ${TABLET_MIN_PX - BELOW}px)`,
  tabletUp: `@media (min-width: ${TABLET_MIN_PX}px)`,
  tabletOnly: `@media (min-width: ${TABLET_MIN_PX}px) and (max-width: ${LAPTOP_SM_MIN_PX - BELOW}px)`,
  laptopSmUp: `@media (min-width: ${LAPTOP_SM_MIN_PX}px)`,
  laptopUp: `@media (min-width: ${LAPTOP_MIN_PX}px)`,
  laptopLgUp: `@media (min-width: ${LAPTOP_LG_MIN_PX}px)`,
  desktopUp: `@media (min-width: ${DESKTOP_MIN_PX}px)`,
} as const;
